import { Checkbox, Group, Stack, Text } from '@mantine/core';

import { Departments } from '@/types';

const ALL_DEPARTMENTS = Object.values(Departments);

type Props = {
  value: Departments[];
  onChange: (value: Departments[]) => void;
};

export const DepartmentsCheckboxes = ({ value, onChange }: Props) => {
  const isAllChecked = ALL_DEPARTMENTS.every((department) => value.includes(department));
  const isAnyChecked = ALL_DEPARTMENTS.some((department) => value.includes(department));

  const toggleAll = () => {
    onChange(isAllChecked ? [] : [...ALL_DEPARTMENTS]);
  };

  const toggle = (department: Departments) => {
    const next = value.includes(department)
      ? value.filter((selected) => selected !== department)
      : [...value, department];
    onChange(next);
  };

  return (
    <Stack gap="xs">
      <Checkbox
        label={
          <Text size="sm" fw={600}>
            All
          </Text>
        }
        checked={isAllChecked}
        indeterminate={!isAllChecked && isAnyChecked}
        onChange={toggleAll}
      />
      <Group gap="lg" align="center">
        {ALL_DEPARTMENTS.map((department) => (
          <Checkbox
            key={department}
            label={department.toUpperCase()}
            checked={value.includes(department)}
            onChange={() => toggle(department)}
          />
        ))}
      </Group>
    </Stack>
  );
};
